<template>
  <div id="app" :class="'lang-' + lang">
    <!-- <i18nBtn class="fixed-i18n-btn" /> -->
    <router-view />
  </div>
</template>

<script>
import i18nBtn from "./common/components/i18n-btn";

export default {
  name: "App",
  data() {
    return {
      lang: 'zh'
    }
  },
  watch: {
    "$i18n.locale": "i18nHandle"
  },
  created() {
    this.i18nHandle(this.$i18n.locale);
  },
  methods: {
    i18nHandle(val, oldVal) {
      this.lang = val
      this.common.setCookie("lang", val, null, "/", this.domain);
      document.querySelector("html").setAttribute("lang", val);
    }
  },
  components: {
    i18nBtn
  }
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;

  .fixed-i18n-btn {
    position: fixed;
    z-index: 100;
    top: 16px;
    right: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue